import { generateUuid } from '../../../utils/uuids'
import { WbsItemSubStatusResponse } from '../../../infrastructure/api/wbs-item-sub-statuses'
import { WbsItemStatus } from '../../../domain/entity/WbsItemEntity'
import { ListRow } from '../../containers/BulkSheetView/model'
import { UserBasic } from '../../../lib/functions/user'

// BulkSheetViewの行データ型。
// rowNumber / added / edited / editedData / revision / createdAt(By) / updatedAt(By) は ListRow から継承する。
// added行はクライアント側で追加した未保存行(uuidはgetRowId用の一時キーで、保存時はサーバーに送らない)。
export interface SubStatusRow extends ListRow {
  name: string
  linkedStatus: WbsItemStatus
  // WBSアイテムに設定済みかどうか。使用中のものは削除できない(参照先が失われるため)。
  isUsed?: boolean
  // 表示順(0始まり)。プリセット・カスタムを問わず並べ替え対象。
  displayOrder: number
}

type UserBasicResponse = NonNullable<WbsItemSubStatusResponse['createdBy']>

// レスポンスのUserBasic(code/iconUrl/nameが省略され得る)を、ListRowが要求するUserBasicに寄せる。
// 監査列は name / iconUrl をパス参照して描画するだけなので、欠損は空文字で埋めて差し支えない。
const toListRowUser = (user?: UserBasicResponse): UserBasic | undefined =>
  user && {
    uuid: user.uuid,
    code: user.code ?? '',
    iconUrl: user.iconUrl ?? '',
    name: user.name ?? '',
  }

export const fromResponse = (res: WbsItemSubStatusResponse): SubStatusRow => ({
  uuid: res.uuid,
  name: res.name,
  linkedStatus: res.linkedStatus,
  isUsed: res.isUsed,
  displayOrder: res.displayOrder,
  revision: res.revision,
  createdAt: res.createdAt,
  createdBy: toListRowUser(res.createdBy),
  updatedAt: res.updatedAt,
  updatedBy: toListRowUser(res.updatedBy),
  added: false,
  edited: false,
})

export const createNewSubStatusRow = (): SubStatusRow => ({
  uuid: generateUuid(),
  name: '',
  linkedStatus: WbsItemStatus.TODO,
  isUsed: false,
  displayOrder: 0,
  added: true,
})

// WBSアイテムに設定済み(使用中)のサブステータスは、削除すると参照先が失われるため削除できない。
// プリセットかどうか(レスポンスのisPreset)は初期投入由来かの記録に過ぎないので、削除可否の判断には使わない。
export const isDeletableSubStatusRow = (row?: SubStatusRow): boolean =>
  !!row && !row.isUsed
